
import Model from './model.js';

export default class Attachment extends Model {
    urlRoot() { return '/Attachments'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }

    /**
     * Get the url of the file in this attachment
     *
     * @instance
     * @returns {string} An empty string if there is no file, or the url of
     *  the file.
     */
    getUrl() {
        return this.downloadUrl();
    }

    /**
     * Test the tags attribute for a specific tag
     *
     * @instance
     * @param {string} tag - The tag to search for
     * @returns {boolean} True if found, false otherwise
     */
    hasTag(tag) {
        return _.contains(this.get('tags'), tag);
    }

    /**
     * Find a tag using a regular expression
     *
     * @instance
     * @param {RegExp} re - The regular expression to test with
     * @returns {string|falsy} The tag if found, a falsy value otherwise
     */
    findTag(re) {
        return _.find(this.get('tags'), re.test.bind(re));
    }

    downloadUrl() {
        return `${this.finalUrl()}/download?` +
            `access_token=${app.user.getAccessToken().id}`;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/attachment.js